import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  title: string
  list: StrapiBlockComponent[]
}

function Highlights({ title, list }: Props) {
  return (
    <section className={clsx('bg-[#090909] text-white relative')}>
      <Image
        src="/assets/index-25/decode-bg-img.png"
        alt="decode-bg-img"
        height="955"
        width="1441"
        className="absolute w-full h-full object-top"
      />
      <div className="container | relative z-10 mx-auto py-10 md:py-18">
        <div className="mb-14 md:mb-20 md:max-w-col-10">
          <h1 className="title text-4xl md:text-5xl font-medium tracking-tight inline">
            {title}
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 justify-center items-start">
          {list.map(ele => (
            <div key={ele.id}>
              <h3
                className="text-3xl lg:text-6xl font-semibold mb-4"
                dangerouslySetInnerHTML={{ __html: ele.title ?? '' }}
              />
              <div
                className="text-xl text-gray-40 inline-block"
                dangerouslySetInnerHTML={{
                  __html: ele.description ?? ''
                }}
              />
            </div>
          ))}
          <div className="flex justify-center items-start">
            <Link
              className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 whitespace-nowrap text-sm font-medium rounded-lg py-2 px-10 w-full md:w-auto"
              href={'#invite-only'}
            >
              Register Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Highlights
